module.exports = __webpack_public_path__ + "static/img/home-header-top.93e40bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-header-top.png
// module id = V8Q3
// module chunks = 0